/** ms before the single skin retry, long enough to clear a transient network blip */
const SKIN_RETRY_DELAY = 400;

export const ViewAbstractState = {
	url: '/view',
	abstract: true,
	redirectTo: 'view.consultation', // default child
	template: '<view-abstract-page class="abstract themed"></view-abstract-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "viewAbstractPageMod" */
			'@Containers/view-abstract-page/view-abstract-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	onEnter: $transition$ => {
		const $log = $transition$.injector().get('$log');
		const $timeout = $transition$.injector().get('$timeout');
		const ServiceProviderService = $transition$.injector().get('ServiceProviderService');
		const ThemingService = $transition$.injector().get('ThemingService');

		// generateSkin is itself idempotent, but skipping the request is cheaper than
		// making one only to discard it
		if (ThemingService.existSkin()) return;

		const _params = {
			serviceProviderId: $transition$.params().serviceProviderId,
			consultationId: $transition$.params().consultationId,
			customerToken: $transition$.params().customerToken,
		};

		const attempt = () =>
			ServiceProviderService.getServiceProviderDetailsExcerpt(_params).then(resObj => {
				const {data} = resObj;
				// a success:false body is a failure, throwing routes it into the retry instead of silently failing
				if (!data?.success) throw data?.error || new Error('provider excerpt unavailable');
				ThemingService.generateSkin({
					brandPrimary: data.payLoad.service_provider_primary_color,
					brandSecondary: data.payLoad.service_provider_secondary_color,
				});
			});

		// one delayed retry covers the transient case. Anything worse is logged and the
		// customer gets the default palette, which is a cosmetic loss and never a blank page
		attempt()
			.catch(() => $timeout(attempt, SKIN_RETRY_DELAY))
			.catch(err => $log.error('view: provider skin could not be applied', err));
	},
	onExit: $transition$ => {
		const ThemingService = $transition$.injector().get('ThemingService');
		ThemingService.resetSkin();
	},
	resolve: [
		{
			token: 'logAccess',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.postLogAccess({...trans.params()}),
		},
	],
};
